import { ReactElement } from "react";
import "../styles/navbar.css";
import { useNavigate } from "react-router-dom";

interface NavProps {
  logo: ReactElement;
}

export default function NavbarFrancaPQR({ logo }: NavProps) {
  const navigate = useNavigate();

  return (
    <div className="navbarfranca">
      <div className="navbar_EST">EST. 2013</div>

      <div className="navbar_title">{logo}</div>
      <div className="navbar_contact">
        <div className="navbar_contact_list">
          <div>
            <a
              className="navbar_contact_list_enlace_wpp"
              href="https://wa.link/bentml"
              target="_blank"
            >
              <span>whatsapp</span>
            </a>
          </div>
          <div className="divider"></div>
          <div>
            <a
              className="navbar_contact_list_enlace_agendece"
              href="https://calendar.app.google/xc5RXbhFtL2aWn6d7"
              target="_blank"
            >
              <span>agéndese</span>
            </a>
          </div>
          <div className="divider"></div>
          <div onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
            <span>Inicio</span>
          </div>
        </div>
      </div>
    </div>
  );
}
